export default "__VITE_ASSET__3440cf38__"